<div class="cardWidget clickable" (click)="launchNavigation()">
    <div class="cardWidget-header">
        <span class="cardWidget-header-title" [i18n]="buttonTitleKey"></span>
        <i class="indicationIcon fa fa-external-link-alt"></i>
    </div>

    <div class="cardWidget-content flex-row">
        <p [i18n]="buttonDescription"></p>
        <i class="iconWidgetButton {{iconButton}}"></i>
    </div>
</div>
